import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { VehicleCategoryService } from '../proxy/general/controllers/vehicle-category.service';

FieldBuilder.setNamespace('General');

export const VEHICLETYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.VehicleType.Name')
    .required()
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.VehicleType.Code')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('applyLowImpactTruck', 'Entity.VehicleType.ApplyLowImpactTruck')
    .build(),
  FieldBuilder
    .foreignKey('vehicleCategoryId', 'Entity.VehicleCategory', VehicleCategoryService)
    .displayFromNested('vehicleCategory.name') 
    .sortBy('vehicleCategory.name') 
    .build(),
];

export const VEHICLETYPE_CONFIG = {
  entityName: 'VehicleType',
  localizationKey: 'General::Entity.VehicleType',
  fields: VEHICLETYPE_FIELDS,
  permission: 'ControllingStructural.VehicleTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
